module.exports = __webpack_public_path__ + "static/fonts/iconfont.f05811d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.ttf?t=1585034858718
// module id = 571
// module chunks = 8